import { render } from "./AddForeignOffice.vue?vue&type=template&id=7660ea2c&scoped=true"
import script from "./AddForeignOffice.vue?vue&type=script&lang=js"
export * from "./AddForeignOffice.vue?vue&type=script&lang=js"

import "./AddForeignOffice.vue?vue&type=style&index=0&id=7660ea2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7660ea2c"]])

export default __exports__